import { render, staticRenderFns } from "./EnrollDetail.vue?vue&type=template&id=2084e206&scoped=true&"
import script from "./EnrollDetail.vue?vue&type=script&lang=js&"
export * from "./EnrollDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084e206",
  null
  
)

export default component.exports